import { Link } from "react-router-dom";
import { ShieldCheck, Mail, Linkedin, Instagram, Facebook, MapPin } from "lucide-react";
import { NAV_LINKS } from "../data/content";
import ParentCompanyNotice from "./ParentCompanyNotice";

const socials = [
  { icon: Linkedin, label: "LinkedIn" },
  { icon: Instagram, label: "Instagram" },
  { icon: Facebook, label: "Facebook" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative mt-24 border-t border-white/10 bg-ink">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-gradient">
                <ShieldCheck className="h-5 w-5 text-white" strokeWidth={2.2} />
              </span>
              <span className="font-heading text-lg font-semibold text-white">Nova SecureNet</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-brand-gold">Security Made Simple.</p>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-muted-foreground">
              Helping Canadian businesses build, secure, and grow their online presence.
            </p>
            <div className="mt-6 flex gap-3">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href="#"
                  aria-label={`${s.label} (coming soon)`}
                  title="Coming soon"
                  onClick={(e) => e.preventDefault()}
                  data-testid={`social-${s.label.toLowerCase()}`}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-muted-foreground transition-colors duration-300 hover:border-brand/50 hover:text-white"
                >
                  <s.icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white">Explore</h4>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-muted-foreground transition-colors hover:text-white">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white">Contact</h4>
            <ul className="mt-5 space-y-3 text-sm text-muted-foreground">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-brand" />
                <a href="mailto:matthew@novasecurenet.com" className="transition-colors hover:text-white">
                  matthew@novasecurenet.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-brand" />
                <span>Canada · Remote-first</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white">Get Started</h4>
            <p className="mt-5 text-sm leading-relaxed text-muted-foreground">
              Ready to build something dependable? Request a free consultation today.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="mt-5 inline-flex items-center rounded-full bg-brand-gradient px-6 py-3 text-sm font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5"
            >
              Book a Consultation
            </Link>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-sm text-muted-foreground md:flex-row">
          <div className="flex flex-col items-center gap-1.5 md:items-start">
            <p>© {new Date().getFullYear()} Nova SecureNet. All rights reserved.</p>
            <ParentCompanyNotice className="text-xs" />
          </div>
          <div className="flex gap-6">
            <Link to="/privacy" className="transition-colors hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="transition-colors hover:text-white">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
